/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactFromJSON, ContactToJSON } from './Contact';
import { ContactSettingFromJSON, ContactSettingToJSON } from './ContactSetting';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetContactsResponseDataFromJSON(json) {
    return GetContactsResponseDataFromJSONTyped(json, false);
}
export function GetContactsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contacts: !exists(json, 'contacts') ? undefined : json['contacts'].map(ContactFromJSON),
        contactSettings: !exists(json, 'contact_settings')
            ? undefined
            : json['contact_settings'].map(ContactSettingFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetContactsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contacts: value.contacts === undefined ? undefined : value.contacts.map(ContactToJSON),
        contact_settings: value.contactSettings === undefined ? undefined : value.contactSettings.map(ContactSettingToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
